import { render, staticRenderFns } from "./ButtonAddToCart.vue?vue&type=template&id=06805504&scoped=true"
import script from "./ButtonAddToCart.vue?vue&type=script&lang=js"
export * from "./ButtonAddToCart.vue?vue&type=script&lang=js"
import style0 from "./ButtonAddToCart.vue?vue&type=style&index=0&id=06805504&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06805504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06805504')) {
      api.createRecord('06805504', component.options)
    } else {
      api.reload('06805504', component.options)
    }
    module.hot.accept("./ButtonAddToCart.vue?vue&type=template&id=06805504&scoped=true", function () {
      api.rerender('06805504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/ButtonAddToCart.vue"
export default component.exports